import {
  GetRewardsByTierQuery,
  GetRewardsByTierQueryVariables,
  TierEnum
} from 'graphql.types';
import { useQuery } from '@apollo/client';

import { Reward } from 'settings/Settings.types';

import { getRewardsByTier } from 'settings/graphql/getRewardsByTier';

type RewardTierConfigResponse = {
  loading: boolean;
  rewards: Reward[];
};

export function useRewardTierConfig(tier: TierEnum): RewardTierConfigResponse {
  const { loading, data } = useQuery<
    GetRewardsByTierQuery,
    GetRewardsByTierQueryVariables
  >(getRewardsByTier, { variables: { tier } });

  const rewards = !loading && data ? data.rewardsByTier : [];

  return { loading, rewards };
}
